module.exports = __webpack_public_path__ + "static/media/ebuilt-video-banner.cbc352ce.webp";